// extracted by mini-css-extract-plugin
export default {"action-buttons":"dx6Wo","not-selectable":"wegfg","ftp-header":"kxxMb","ftp-url":"uXuot","isoform-option":"sPgmp","multiple-values-section":"MIrQv","new-fasta-header":"mc69P"};